// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `apps/stessa-angular/angular.json`.

export const environment = {
  production: false,
  STESSA_API_URL: 'https://api-dev-stessa.coditas.org/v1',
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyC-1-mtNlTlkbWC_z5AWkF_WbgCE5u4VEg',
    authDomain: 'asset-tracker-e67b5.firebaseapp.com',
    projectId: 'asset-tracker-e67b5',
    storageBucket: 'asset-tracker-e67b5.appspot.com',
    messagingSenderId: '941625701626',
    appId: '1:941625701626:web:1f8a13ecff4d2c0b754543',
    measurementId: 'G-K96T34VEBH',
  },
  GSC_CLIENT_ID:
    '436789456176-g7u48of941dfkqpe2kcvm1g2a40qb9d6.apps.googleusercontent.com',
  BASIC_AUTH: 'rECJrar6W1',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
